import { Injectable, inject } from '@angular/core';
import { CookieService as NgxCookieService } from 'ngx-cookie-service';
import { prefixedKey } from './storage-keys';

@Injectable({
    providedIn: 'root',
})
export class CookieService {
    private NgxCookieService = inject(NgxCookieService);

    private getKeyWithPrefix(key: string): string {
        return prefixedKey(key);
    }

    getCookie(name: string): string | null {
        const keyWithPrefix = this.getKeyWithPrefix(name);
        const value = this.NgxCookieService.get(keyWithPrefix);
        return value || null;
    }

    setCookie(name: string, value: string, days: number = 7): void {
        const keyWithPrefix = this.getKeyWithPrefix(name);
        const expires = new Date();
        expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

        this.NgxCookieService.set(keyWithPrefix, value, {
            expires,
            path: '/',
            sameSite: 'Strict',
            secure: location.protocol === 'https:',
        });
    }

    deleteCookie(name: string): void {
        const keyWithPrefix = this.getKeyWithPrefix(name);
        this.NgxCookieService.delete(keyWithPrefix, '/');
    }
}
